export default "__VITE_ASSET__BFsmpBqn__"